import { colors } from "config/theme/colors";
import { fonts } from "config/theme/fonts";
import { DefaultTheme } from "styled-components";

export type ColorsTypes = typeof colors;
export type FontsTypes = typeof fonts;

export const theme: DefaultTheme = {
  colors,
  fonts: fonts,
};
